import * as _ from "lodash";
import * as angular from "angular";
import { Organisation } from "../../models/organisation.model";
import { User } from "../../models/user.model";
import { OrganisationInviteService } from "../../services/organisation-invite.service";
import { OrganisationInviteDataProvider } from "../../data-provider/organisation-invite.dp";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { OrganisationDataProvider } from "../../data-provider/organisation.dp";
import { DivisionDataProvider } from "../../data-provider/division.dp";
import { Division } from "../../models/division.model";
import { Campaign } from "../../models/campaign.model";
import { UserDataProvider } from "../../data-provider/user.dp";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { Limit } from "../../models/limit.model";
import { OrganisationUserDataProvider } from "../../data-provider/organisation-user.dp";

let LeaderUserComponent = {
    selector: "vcLeaderUser",
    templateUrl:
        "/angular/components/organisation-user/leader-user.component.html",
    bindings: {
        organisation: "=?",
        selectedUser: "=?",
    },
    controller: class LeaderUserController {
        // * bindings for typescript compiler *
        public organisation?: Organisation;
        public selectedUser?: User;
        // ************************************

        private organisationInviteService: OrganisationInviteService;
        private organisationInviteDataProvider: OrganisationInviteDataProvider;
        private permissionCheck: PermissionCheck;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        private organisationDataProvider: OrganisationDataProvider;
        private divisionDataProvider: DivisionDataProvider;
        private userDataProvider: UserDataProvider;
        private limitDataProvider: LimitDataProvider;
        private organisationUserDataProvider: OrganisationUserDataProvider;

        public error: string = "";
        public search: string = "";
        public user: User;
        public signedInUser: User;
        public permissions;
        public limitExceededPage: boolean;
        public invite_loading: boolean;
        public errorMessage: string;
        public divisions: Division[];
        public nonDivision: Division;
        public usersCount: object;
        public limits: Limit;

        constructor(
            $scope: any,
            OrganisationInviteService: OrganisationInviteService,
            OrganisationInviteDataProvider: OrganisationInviteDataProvider,
            PermissionCheck: PermissionCheck,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            OrganisationDataProvider: OrganisationDataProvider,
            UserDataProvider: UserDataProvider,
            DivisionDataProvider: DivisionDataProvider,
            LimitDataProvider: LimitDataProvider,
            OrganisationUserDataProvider: OrganisationUserDataProvider
        ) {
            this.organisationInviteService = OrganisationInviteService;
            this.organisationInviteDataProvider =
                OrganisationInviteDataProvider;
            this.permissionCheck = PermissionCheck;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.organisationDataProvider = OrganisationDataProvider;
            this.divisionDataProvider = DivisionDataProvider;
            this.organisationUserDataProvider = OrganisationUserDataProvider;
            this.permissions = this.permissionCheck.levels;

            this.userDataProvider = UserDataProvider;
            this.signedInUser = this.userDataProvider.getActiveUser();
            this.userDataProvider
                .getUsersCount()
                .then((count: object) => (this.usersCount = count));

            this.limitDataProvider = LimitDataProvider;
            this.limitDataProvider
                .get()
                .then((limits: Limit) => (this.limits = limits));
        }

        $onInit() {
            this.user = _.cloneDeep(this.selectedUser);
            if (!this.user.campaigns) {
                let uid = this.user && this.user.uid ? this.user.uid : null;
                if (uid) {
                    this.organisationUserDataProvider
                        .getUser(uid)
                        .then((user: User): void => {
                            this.user.setData(user);
                        });
                }
            }
            this.divisionDataProvider
                .getAllDivisions()
                .then((divisions: Division[]) => {
                    this.divisions = _.filter(
                        divisions,
                        (division: Division) => division.id != null
                    );

                    this.nonDivision = _.first(
                        _.filter(
                            divisions,
                            (division: Division) => division.id == null
                        )
                    );

                    this.invite_loading = false;

                    if (
                        this.isCampaignLevel(this.user.permission.permissionid)
                    ) {
                        let userCampaignIds = this.user.campaigns
                            ? this.user.campaigns.map(
                                  (campaign) => campaign.campaignid
                              )
                            : [];
                        angular.forEach(divisions, (division) => {
                            division.tab = false;
                            angular.forEach(division.campaigns, (campaign) => {
                                if (
                                    userCampaignIds.includes(
                                        campaign.campaignid
                                    )
                                )
                                    division.tab = true;
                            });
                        });
                        this.nonDivision.tab = false;
                        angular.forEach(
                            this.nonDivision.campaigns,
                            (campaign) => {
                                if (
                                    userCampaignIds.includes(
                                        campaign.campaignid
                                    )
                                )
                                    this.nonDivision.tab = true;
                            }
                        );
                    }
                });

            if (!this.user.permission) {
                this.user.permission = _.cloneDeep(
                    this.permissions.find(
                        (permission: any): boolean =>
                            permission.permissionid === this.user.permissionid
                    )
                );
            }
        }

        anyCampaignsMatchSearch(campaigns: Array<Campaign>): boolean {
            return (
                campaigns.filter(
                    (campaign) =>
                        campaign.campaignname
                            .toLowerCase()
                            .indexOf(this.search.toLowerCase()) > -1
                ).length > 0
            );
        }

        deleteInvite(invite: any, ev): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    fullscreen: true,
                    skipHide: true,
                    locals: {
                        bodyText: `It will be permanently deleted`,
                        title: `Delete Invite?`,
                    },
                })
                .then(() => {
                    this.organisationInviteDataProvider
                        .deleteInvite(invite)
                        .then(() => {
                            this.toast.success("Invite Deleted");
                        });
                });
        }

        updateInvite(data: object): void {
            this.organisationInviteService.update(data).then((response) => {
                let json = response["data"];
                this.invite_loading = false;
                if (json.success) {
                    this.toast.success("Invite Updated");
                    this.dialog.hide(this.user);
                } else {
                    this.errorMessage = json.message;
                }
            });
        }

        save(organisation, divisions): void {
            this.updatePermission();
            this.invite_loading = true;
            if (
                this.selectedUser.license_type != this.user.license_type &&
                this.limitDataProvider.licensesUnavailable(
                    this.user.license_type,
                    this.usersCount,
                    1
                )
            ) {
                this.limitExceededPage = true;
                this.invite_loading = false;
                return;
            }
            if (this.user.hasOwnProperty("uid") && this.user.uid) {
                this.updateUser();
            } else {
                let data = _.cloneDeep(organisation);
                data.permissionid = this.user.permission.permissionid;
                data.divisionids =
                    data.permissionid == 10 && this.user.permission.divisions
                        ? this.user.permission.divisions
                        : null;

                data.organisationinviteid = this.user.organisationinviteid;
                this.updateInvite(data);
            }
        }

        isCampaignLevel(permissionid: number): boolean {
            return (
                permissionid == 2 ||
                permissionid == 3 ||
                permissionid == 4 ||
                permissionid == 5 ||
                permissionid == 6
            );
        }

        isCampaignChecked(campaignid: string): boolean {
            return _.map(
                this.user.campaigns,
                (campaign: Campaign) => campaign.campaignid
            ).includes(campaignid);
        }

        updateUser(): void {
            if (
                this.isCampaignLevel(this.user.permission.permissionid) &&
                !this.user.campaigns.length
            ) {
                this.errorMessage =
                    "You must select at least one account for this user to be a part of";
                this.invite_loading = false;
            } else {
                this.errorMessage = null;
                this.organisationDataProvider
                    .updateUser(this.user)
                    .then((success) => {
                        if (success) {
                            this.toast.success("User updated");
                            this.dialog.hide(this.user);
                        } else {
                            this.toast.error("Failed to update user");
                        }
                    })
                    .catch((error) => {
                        this.toast.error("Failed to update user");
                    });
                this.userDataProvider.resetUsersCount();
            }
        }

        updatePermission(): void {
            angular.forEach(this.permissions, (permission) => {
                if (
                    permission.permissionid == this.user.permission.permissionid
                ) {
                    this.user.permission.permissionname =
                        permission.internalName;
                    this.user.updateLicenseType();
                }
            });
            if (this.user.permission.permissionid != 10) {
                this.user.permission.divisions = null;
            } else if (this.user.permission.permissionid == 10) {
                this.user.permission.divisions =
                    this.user.permission.divisions || [];
            }
        }

        selectCampaign(campaign: Campaign): void {
            if (this.isCampaignChecked(campaign.campaignid)) {
                const $index = this.user.campaigns.findIndex(
                    (c) => c.campaignid === campaign.campaignid
                );
                this.user.campaigns.splice($index, 1);
            } else {
                this.user.campaigns.push(campaign);
            }
        }

        clickDivision(division): void {
            if (!this.user.permission.divisions) {
                this.user.permission.divisions = [];
            }

            if (this.isDivisionChecked(division)) {
                const $index = this.user.permission.divisions.indexOf(
                    division.id
                );
                this.user.permission.divisions.splice($index, 1);
            } else {
                this.user.permission.divisions.push(division.id);
            }
        }

        isDivisionChecked(division: Division): boolean {
            return (
                !!this.user.permission.divisions &&
                this.user.permission.divisions.includes(division.id)
            );
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("organisationUser", [])
    .component(LeaderUserComponent.selector, LeaderUserComponent);
